module.exports = __webpack_public_path__ + "static/media/familie_2023.f81bb152.jpeg";